import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SERVICES_PREFIX } from '../../../base/config';
import { Report } from '../types';

// Define a service using a base URL and expected endpoints
export const inspectionReportApi = createApi({
    reducerPath: 'inspections2',
    baseQuery: fetchBaseQuery({ baseUrl: SERVICES_PREFIX }),
    endpoints: (builder) => ({
        getReport: builder.query<Report, string>({
            // query: (inspectionId) => 'inspections/' + inspectionId + '/report',
            query: (inspectionId) => ({
                url: 'inspections/' + inspectionId + '/report',
                headers: { authorization: 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJRYXJtYUluc3BlY3QiLCJlcGMiOjEsImV4cCI6MTcwNTQwNjY0MSwiaWF0IjoxNjczODcwNjQxLCJpc3MiOiJRYXJtYUluc3BlY3QiLCJqdGkiOiIwYzU5MzIyZS0zM2QyLTQ2NTgtOTlmZi00ZjI5NmQxNGM2ZTUiLCJuYmYiOjE2NzM4NzA2NDAsIm9yZyI6IjEwOWZmZDdjLWM3ZTYtNDFhYi04MzU0LTliOTY0ZjdhNzE5ZiIsInN1YiI6IjQwYzBmNzNhLWM3ZjMtNGRlYy05YjdkLWNjM2FkYjA1NGFiMyIsInR5cCI6InRva2VuIn0.uycBM4SGKn34EWsa7lHNYWDig4mV3ovaDxoCnTaU8mjW9OEtHF_MEoKQSPekkPGvUkEqPOLiTTy2TMLLI8_maA' },
            })
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetReportQuery } = inspectionReportApi;